/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EPresciptionINFOEXECUTIONInnerEXECUTIONInnerLIGEXECUTIONInnerLIGINFIRMIER { 
    CodeDetailExecution?: string;
    CommentairePS?: string;
    DetailExecution?: string;
    Id?: number;
}

